import { Termin } from '@/domain/termine/shared/types/Termin';
import { Day } from '@/domain/termine/type';
import { cn } from '@/lib/utils';
import { useTranslation } from 'react-i18next';
import { DayCell } from '@/domain/termine/features/Calendar/shared/DayCell/DayCell';

interface DayCellWrapperProps {
  day: Day;
  termineForDay: Termin[];
  isToday: boolean;
  hasFeiertag: boolean;
  isTodayInWeek: boolean;
  isTodayTermin: boolean;
}

export function ListDayCell({
  day,
  termineForDay,
  isToday,
  hasFeiertag,
  isTodayInWeek,
  isTodayTermin,
}: DayCellWrapperProps) {
  const { t } = useTranslation();

  if (termineForDay.length > 0) {
    return (
      <div className={cn(hasFeiertag && 'py-2')}>
        <DayCell day={day} />
      </div>
    );
  }

  if (isToday && isTodayInWeek && !isTodayTermin) {
    return (
      <div className="flex p-4 bg-neutrals-300 w-full rounded-lg shadow-xs transition-colors justify-center">
        {t('domain.termine.heutekeinenTermin')}
      </div>
    );
  }
  return <></>;
}
